import React from 'react';
import heroImage from '../../assets/images/hero.png'

export default React.memo(function HeroBlock({ src, children, showImage = true, showOverlay = true, className = '', childWrapperClassName = '' }) {

  return (
    <section
      className={`relative w-full min-h-screen bg-brand-primary overflow-hidden ${className} ${showOverlay ? 'before:absolute after:bg-black after:opacity-50 before:inset-0  before:z-[-1]' : ''}`}>{/*after:bg-brandedRed*/}
      {showImage &&
        <img src={src ? src : heroImage} alt={'hero'}
                   className={`block w-full md:w-[80vw] lg:w-[60vw] absolute bottom-1 left-1/2 transform -translate-x-1/2 translate-y-1/2 overflow-hidden z-[0]`} />
      }
      <div className={`relative w-full min-h-screen flex items-center pb-4 pt-32 md:pt-40 ${childWrapperClassName}`}>
        {children}
      </div>
    </section>
  );
})
